import type { LocalOverviewNode } from 'src/types/flows.types';

export function getAngle(idx: number, total: number) {
  const separationAngle = total > 10 ? 10 : 16;
  const baseAngle = -((total - 1) * separationAngle) / 2;

  const degrees = idx * separationAngle;
  return baseAngle + degrees + 0; // get rid of negative zero
}

export function getDirectionCounts(nodes: LocalOverviewNode[]) {
  return nodes.reduce(
    (acc, curr) => {
      const side = curr.direction === 'outgoing' ? 'right' : 'left';
      acc[side] = acc[side] + 1;
      return acc;
    },
    { left: 0, right: 0 }
  );
}
